import axios from "axios";

const buildtype = process.env.NODE_ENV
console.log("process.env.NODE_ENV=======>",process.env.NODE_ENV)
var baseUrl=''
switch (buildtype) {
    case 'production': // 实际生产环境
        baseUrl="https://followupcenter.huidr.com/api";
        break;
    case 'development': //开发
        baseUrl="https://followup.test.huidr.com/api";
        break;
    case 'test': //测试
        baseUrl="https://followup.test.huidr.com/api";
        break;
    case 'LOCAL':
        baseUrl="https://followup.test.huidr.com/api";
        break;

}
const service = {
    requestAjax(ajax) {
        console.log(ajax,buildtype)
        return axios({
            url: baseUrl+ajax.url,
            method:ajax.method,
            data: JSON.stringify(ajax.data),
            headers:ajax.headers || { 'Content-Type': 'application/json' },
            responseType: ajax.responseType
        })
    },
    sendAjax(ajax) {
        return new Promise(resolve => {
            axios({
                url: baseUrl,
                method:ajax.method,
                data: JSON.stringify(ajax.data),
                headers: ajax.headers ||{ 'Content-Type': 'application/json' },
                responseType: ajax.responseType
            })
                .then((res) => {
                    console.log(res)
                })
        })
    },
    /**
     *
     * @param {Object} params
     * 请求格式为{
     *    request: [
     *        query: {
     *          type: 'xxx',
     *          data: data,
     *        }
     *    ]
     * }
     */
    requestFn(params) {
        axios({
            url: params.url,
            method: 'POST',
            data: JSON.stringify(params.data),
            headers: { 'Content-Type': 'application/json' },
        }).then((res) => {
            console.log(res.data.response)
        })
    },
}
export default service
